import type { ReactNode } from "react";
import "./button.css";

export function Button({
  href,
  onClick,
  children,
  variant = "primary",
  target,
  rel,
  iconRight
}: {
  href?: string;
  onClick?: () => void;
  children: ReactNode;
  variant?: "primary" | "secondary" | "ghost";
  target?: string;
  rel?: string;
  iconRight?: ReactNode;
}) {
  const className = ["btn", `btn--${variant}`].join(" ");
  const content = (
    <>
      <span className="btn__label">{children}</span>
      {iconRight ? <span className="btn__icon">{iconRight}</span> : null}
    </>
  );

  if (href) {
    return (
      <a className={className} href={href} target={target} rel={rel}>
        {content}
      </a>
    );
  }
  return (
    <button className={className} onClick={onClick}>
      {content}
    </button>
  );
}

